import React from 'react';

const FloatingCallButton = () => {
  return (
    <a
      href="tel:8192002015"
      data-testid="floating-call-button"
      className="fixed bottom-5 right-5 z-[90] group"
      aria-label="Appeler Groupe Lavage Fenêtres"
    >
      <div className="relative">
        <img
          src="/logo-glf.png"
          alt="Appeler"
          className="h-14 md:h-16 w-auto rounded-xl shadow-lg group-hover:shadow-xl transition-all group-hover:scale-105"
        />
        {/* Pulse ring */}
        <div className="absolute inset-0 rounded-xl border-2 border-cyan-400/50 animate-ping opacity-30" />
      </div>
    </a>
  );
};

export default FloatingCallButton;
